import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';

@Injectable()
export class RestApiService {

  constructor(
    private httpClient: HttpClient
  ) { }

  get<T>(url: string): Observable<T> {
    return this.httpClient.get<T>(`${environment.origin}/api/${url}`);
  }

  post<T>(url: string, data: any): Observable<T> {
    return this.httpClient.post<T>(`${environment.origin}/api/${url}`, data);
  }

  put<T>(url: string, data: any): Observable<T> {
    return this.httpClient.put<T>(`${environment.origin}/api/${url}`, data);
  }

  delete<T>(url: string): Observable<T> {
    return this.httpClient.delete<T>(`${environment.origin}/api/${url}`);
  }
}
